import axios from 'axios';
import { URI } from '../helpers/constans';

export type TShareReactionType =
  | 'like'
  | 'love'
  | 'fire'
  | 'shock'
  | 'effort';

export type AddMemorableMomentPayload = {
  qdosItemId: string;
  qdosEventId: string;
  qdosPostId: string;
  alternativeId?: string;
  mediaType?: string;
  imageId?: string;
  videoUrl?: string;
  description?: string;
  eventTitle?: string;
};

export type AddToSharePayload = AddMemorableMomentPayload & {
  shareType: 'team' | 'fan';
};

export const addToShare = (payload: AddToSharePayload) => {
  return axios.post(`${URI}/share/items`, payload);
};

export const getTeamShare = (eventId: string) => {
  return axios.get(`${URI}/share/events/${eventId}/team`);
};

export const getFanShare = (eventId: string) => {
  return axios.get(`${URI}/share/events/${eventId}/fan`);
};

export const getTeamShareHistory = () => {
  return axios.get(`${URI}/share/events/team/history`);
};

export const getFanShareHistory = () => {
  return axios.get(`${URI}/share/events/fan/history`);
};

export const setShareReaction = (
  id: string,
  reactionType: TShareReactionType,
) => {
  return axios.post(`${URI}/share/items/${id}/reaction`, { reactionType });
};

export const removeShareReaction = (id: string) => {
  return axios.delete(`${URI}/share/items/${id}/reaction`);
};

export const likeShareItem = (id: string) => {
  return axios.post(`${URI}/share/items/${id}/like`);
};

export const unlikeShareItem = (id: string) => {
  return axios.delete(`${URI}/share/items/${id}/like`);
};

export const removeShareItem = (id: string) => {
  return axios.delete(`${URI}/share/items/${id}`);
};

export const addMemorableMoment = (payload: AddMemorableMomentPayload) => {
  return axios.post(`${URI}/memorable-moments`, payload);
};

export const getMemorableMoments = () => {
  return axios.get(`${URI}/memorable-moments`);
};

export const deleteMemorableMoment = (id: string) => {
  return axios.delete(`${URI}/memorable-moments/${id}`);
};